export default __webpack_public_path__ + "static/media/hkmtr2.b47b8718.jpeg";